import {createNullableContext} from '../context';
import {SubscriptionScreenProps} from './PurchaseScreen';

export const PurchaseScreenContext =
  createNullableContext<SubscriptionScreenProps>();
